export const environment = {
    production: false,
    baseUrl: 'https://apistaging.anybid.co.uk/api/v1/',
    chat: 'https://apistaging.anybid.co.uk/chatHub',
    domainUrl: 'https://apistaging.anybid.co.uk/connect/ziina',
  routeCryptoPassphrase: 'anybid-dev-route-crypto-phrase-replace',
  paypalClientId:
    'AX_51HqppUQIn5WOtnEgxsrVXYqDfTl-3BWfuc8KlQu_EbyFE2Q7hR-8LEP4iafGgJrw6f3txjWpeEyW',
  paypalCurrency: 'GBP'
};